// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddUserModal_modal__19YQ9","input":"AddUserModal_input__1q6U7","modalBody":"AddUserModal_modalBody__2XNFT","label":"AddUserModal_label__3ktYx"};